<template>
  <div class="content">
    <div class="row">
      <div class="col-md-8 flex-container-top">
        <base-button type="primary" round icon class="top-button-back" @click="$router.push('list')">
          <i class="fa fa-arrow-left"></i>
        </base-button>
        <h2 class="text-center">Event Bookings List</h2>
      </div>
      <div class="col-md-4 flex-container-top" v-if="this.event.event_type == 'Tournament' && this.event.waiver_form_mandatory">
        <base-button type="primary" class="top-button pull-right"
          @click="downloadAllWaiverForms()">
          Download All Waiver Forms
        </base-button>
      </div>
  </div>
    <div class="col-md-12 flex-container-top mb-2 flex-wrap">
      <div class="col-md-4" v-if="this.event.skill_level_optional">
        <label style="color:white !important;">Skill Level :</label>
        <select class="location form-control" v-model="skill_level" style="width:100%; color:white !important;" placeholder="skill level">
          <option style="color:black !important;">Beginner</option>
          <option style="color:black !important;">Intermediate</option>
          <option style="color:black !important;">Advanced</option>
        </select>
      </div>
      <div class="col-md-4" v-if="this.event.event_type == 'Tournament' && this.event.tournament_type != 'Open'">
        <label style="color:white !important;">Gender :</label>
        <select class="location form-control" v-model="gender" style="width:100%; color:white !important;">
          <option style="color:black !important;" :disabled="this.event.tournament_type == 'Women'">Men</option>
          <option style="color:black !important;" :disabled="this.event.tournament_type == 'Men'">Women</option>
        </select>
      </div>
      <div class="col-md-4" v-if="this.event.event_type == 'Tournament' && this.event.booking_with_team">
        <base-input type="number" class="mb-0 text-white" maxlength="3" label="Team" placeholder="Team" v-model="team">
        </base-input>
      </div>
    </div>
    <div class="col-md-12 flex-container-top flex-wrap">
      <div class="col-md-4">
        <Select2Ajax v-model="selectedAjax" class="location form-control"
                    :skill_level="this.skill_level"
                    :event_type="this.event.event_type"
                    :gender="this.gender"
                    :skill_level_optional="this.event.skill_level_optional"
                    :tournament_type="this.event.tournament_type"
                    :team="this.team">
        </Select2Ajax>
      </div>

      <div class="col-md-2" v-if="!this.event.only_team_booking">
        <label class="readable-label">&nbsp;</label>
        <button class="btn btn-fill pull-right" @click="addGuest()">
          <i class="fa fa-user-plus"></i> &nbsp; Add Guest
        </button>
      </div>

      <div class="col-md-2" v-if="this.event.event_type == 'Tournament' && this.event.booking_with_team">
        <label class="readable-label">&nbsp;</label>
        <button class="btn btn-fill pull-right" @click="addTeam()">
          <i class="fa fa-users"></i> &nbsp; Add Team
        </button>
      </div>

      <div class="col-md-2">
        <label class="readable-label">&nbsp;</label>
        <button v-b-modal.modal-1 class="btn btn-fill pull-right btn-danger"><i class="fa fa-times"></i> &nbsp; Cancel All
        </button>
      </div>

      <div class="col-md-2">
        <label class="readable-label">&nbsp;</label>
        <button v-b-modal.modal-2 class="btn btn-fill pull-right btn-danger"><i class="fa fa-comments" aria-hidden="true"></i> &nbsp; Message All
        </button>
      </div>
    </div>
    <b-modal id="modal-1" title="Send Message" class="bg-dark" style="background-color:#12121B;" hide-footer>
      <form>
        <textarea style="width: 100%" v-model="message"></textarea>
        <br>
        <base-checkbox class="text-left" v-model="credit_refund" v-if="this.event.event_type == 'Tournament'">Credit refund?</base-checkbox>
        <input type="button" value="Submit" class="btn btn-primary col-4" @click="CancelEvent(message)">
        <input type="button" value="Close" class="btn btn-dark col-4" @click="$bvModal.hide('modal-1')">
      </form>
    </b-modal>
    <b-modal id="modal-2" title="Send Group Message" class="bg-dark" style="background-color:#12121B;" hide-footer>
      <form>
        <textarea style="width: 100%" v-model="groupMessage"></textarea>
        <br>
        <input type="button" value="Send" class="btn btn-primary col-4" @click="sendGroupMessage(groupMessage)">
        <input type="button" value="Close" class="btn btn-dark col-4" @click="$bvModal.hide('modal-2')">
      </form>
    </b-modal>
    <div class="row mt-5">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">Event Bookings List</h4>
          <div>
            <div class="
                col-12
                d-flex
                justify-content-center justify-content-sm-between
                flex-wrap
              ">
              <el-select class="select-primary mb-3 pagination-select" v-model="pagination.perPage"
                placeholder="Per page">
                <el-option class="select-primary" v-for="item in pagination.perPageOptions" :key="item" :label="item"
                  :value="item">
                </el-option>
              </el-select>

              <base-input>
                <el-input type="search" class="mb-3 search-input" clearable prefix-icon="el-icon-search"
                  placeholder="Search records" v-model="searchQuery" aria-controls="datatables">
                </el-input>
              </base-input>
            </div>
            <el-table :data="queriedDataBooked">
              <el-table-column :min-width="200" align="left" label="User Details">
                <div slot-scope="props">
                  <div style="display: flex">
                    <div>
                      <div>
                        {{
                          props.row.user_id.first_name +
                            " " +
                            props.row.user_id.last_name
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </el-table-column>
              <el-table-column :min-width="120" align="left" label="Booked Spots">
                <div slot-scope="props">
                  <div style="display: flex">
                    <div>
                      <div>
                        {{ props.row.check_in_status == "CheckIn" ? 1 : 0 }}/ {{ props.row.no_of_bookings }}
                      </div>
                    </div>
                  </div>
                </div>
              </el-table-column>
              <el-table-column :min-width="100" align="left" label="Rental" v-if="this.event.rental_options && this.event.rental_price">
                <div slot-scope="props">
                  <div style="display: flex">
                    <div>
                      <div v-if="props.row.rental_equipment_cnt > 0">
                        {{ props.row.event_id.rental_options ? props.row.event_id.rental_options : ""}} - {{ props.row.rental_equipment_cnt ? props.row.rental_equipment_cnt : 0}}
                      </div>
                    </div>
                  </div>
                </div>
              </el-table-column>
              <el-table-column :min-width="120" align="left" label="Skill Level" v-if="this.event.skill_level_optional">
                <div slot-scope="props">
                  <div style="display: flex">
                    <div>
                      <div v-if="props.row.skill_level">
                        {{ props.row.skill_level ? props.row.skill_level : ""}}
                      </div>
                    </div>
                  </div>
                </div>
              </el-table-column>
              <el-table-column :min-width="120" align="left" label="Gender" v-if="this.event.event_type == 'Tournament' && this.event.tournament_type != 'Open'">
                <div slot-scope="props">
                  <div style="display: flex">
                    <div>
                      <div v-if="props.row.gender">
                        {{ props.row.gender ? props.row.gender : ""}}
                      </div>
                    </div>
                  </div>
                </div>
              </el-table-column>
              <el-table-column :min-width="100" align="left" label="Vaccinated">
                <div slot-scope="props">
                  <div style="display: flex">
                    <div>
                      <div>
                        <div>{{ props.row.user_id.vaccinated }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-table-column>

              <el-table-column :min-width="200" align="left" label="Booked Time">
                <div slot-scope="props">
                  <div>
                    {{ getBookingDateTime(props)}}
                    <!-- {{ moment(props.row.created_at).format('MMMM Do YYYY, h:mm:ss a') }} -->
                  </div>
                </div>
              </el-table-column>

              <el-table-column :min-width="200" align="left" label="Check In Time">
                <div slot-scope="props">
                  <div>
                    <!-- {{ getTime(props) }} -->
                    <!-- {{ props.row.check_in_time ? props.row.check_in_time.toString().slice(0, 16).replace('T', ' ') : "No check-in Time" }} -->
                    {{ props.row.check_in_time ? getCheckInDateTime(props) : "No check-in Time" }}
                    <!-- <div v-if="props.row.check_in_time && props.row.check_in_status == 'CheckIn'">
                    </div> -->
                  </div>
                </div>
              </el-table-column>

              <!-- <el-table-column :min-width="250" align="left" label="Waiver Form" v-if="this.event.waiver_form_mandatory">
                <template slot-scope="props">
                  <el-select placeholder="Waiver form" v-if="props.row.allWaiverFormArray">
                    <el-option
                      v-for="(pdf, index) in props.row.allWaiverFormArray"
                      :key="index"
                      :label="'Pdf ' + (index + 1)"
                      :value="pdf"
                      @click="downloadPDF(pdf)">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column> -->

              <el-table-column :min-width="140" align="left" label="Waiver Form" v-if="this.event.waiver_form_mandatory && this.event.event_type != 'Tournament'">
                <div slot-scope="props">
                  <select class="location form-control" style="width:100%; color:white !important;" aria-placeholder="waiver form"  v-if="props.row.allWaiverFormArray && props.row.allWaiverFormArray.length" @change="downloadPDF($event)">
                    <option value="" disabled selected>Download PDF</option>
                    <option style="color:black !important;" v-for="(pdf, index) in props.row.allWaiverFormArray" :key="index" :value="pdf">pdf {{ index + 1}}
                    </option>
                  </select>
                </div>
              </el-table-column>

              <el-table-column :min-width="350" align="center" label="Status">
                <div slot-scope="props">
                  <div style="display:flex; flex-direction:row; justify-content:space-between"
                    v-if="props.row.user_id.is_guest === false">
                    <base-button style="margin-right: 5px" native-type="submit" type="primary" value="Compares"
                      size="sm" v-if="props.row.check_in_status != 'CheckIn'" @click="UpdateStatus(props.row.user_id)"
                      class="btn-fill" :disabled="loading">CheckIn
                    </base-button>
                    <base-button style="margin-right: 5px" native-type="submit" type="primary" value="Compares"
                      size="sm" v-if="props.row.check_in_status == 'CheckIn'"
                      @click="UpdateStatusAsOut(props.row.user_id)" class="btn-fill" :disabled="loading">CheckOut
                    </base-button>
                    <span v-if="props.row.isLateFeeCharged">No Show Fee Charged</span>
                    <!-- Phase 1 — Task 3E: Charge No Show button is Admin-only.
                         Organizers (hosting events) don't see this button. -->
                    <base-button v-else-if="props.row.isLateFeeCharged == 0 && role === 'Admin'" style="margin-right: 5px" native-type="submit"
                      type="primary" value="Compares" size="sm"
                      @click="chargeNoShow(props.row)" class="btn-fill"
                      :disabled="loading">Charge No Show
                    </base-button>

                    <base-button native-type="submit" type="danger" value="Compares" size="sm"
                      @click="cancelBooking(props.row._id,props.row.user_id)" class="btn-fill" :disabled="loading">Cancel 
                    </base-button>
                  </div>
                  <div style="flex-direction:row; justify-content:space-between"
                    v-if="props.row.user_id.is_guest === true">
                    <base-button native-type="submit" type="danger" value="Delete" size="sm"
                      @click="deleteBookingModal(props.row._id)" class="btn-fill" :disabled="loading">Delete
                    </base-button>
                  </div>
                </div>
              </el-table-column>
            </el-table>
            <modal :show.sync="showLateFeeModal" footerClasses="justify-content-end" type="notice" :show-close="true">
              <h5 slot="header" class="title title-up">Are you sure you want to charge a no-show fee?</h5>
              <div class="row">
                <div class="col-sm-12">
                  <base-input>
                    <el-input type="number" clearable placeholder="Enter Amount" v-model.number="noShowFeeAmount" max="100"
                      min="1">
                    </el-input>
                  </base-input>
                </div>
              </div>
              <template slot="footer">
                <div class="row">
                  <div class="col-sm-2">
                  </div>
                  <div class="col-sm-4">
                    <base-button type="primary" size="lg" @click="addLateFee(selectedUser)">Yes</base-button>
                  </div>
                  <div class="col-sm-4">
                    <base-button type="danger" @click.native="showLateFeeModal = false" size="lg">Close
                    </base-button>
                  </div>
                </div>
              </template>
            </modal>

            <modal :show.sync="deleteConfirm" footerClasses="justify-content-end" type="notice" :show-close="true">
              <h5 slot="header" class="title title-up">Send Message</h5>
              <div class="row">
                <div class="col-sm-12">
                  Do you want to send a message to the wait list users?
                </div>
              </div>
              <template slot="footer">
                <div class="row">
                  <div class="col-sm-2">
                  </div>
                  <div class="col-sm-4">
                    <base-button type="primary" size="lg" @click="deleteBookingGuest(1)">Yes</base-button>
                  </div>
                  <div class="col-sm-4">
                    <base-button type="danger" @click.native="deleteBookingGuest(0)" size="lg">No
                    </base-button>
                  </div>
                </div>
              </template>
            </modal>

          </div>
          <div slot="footer" class="
              col-12
              d-flex
              justify-content-center justify-content-sm-between
              flex-wrap
            ">
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <base-pagination class="pagination-no-border" v-model="pagination.currentPage"
              :per-page="pagination.perPage" :total="total">
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-12" v-if="queriedDataCancelled.length > 0">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">Event Booking Cancelled List</h4>
          <div>
            <div class="
                col-12
                d-flex
                justify-content-center justify-content-sm-between
                flex-wrap
              ">
              <el-select class="select-primary mb-3 pagination-select" v-model="pagination1.perPage"
                placeholder="Per page">
                <el-option class="select-primary" v-for="item in pagination1.perPageOptions" :key="item" :label="item"
                  :value="item">
                </el-option>
              </el-select>

              <base-input>
                <el-input type="search" class="mb-3 search-input" clearable prefix-icon="el-icon-search"
                  placeholder="Search records" v-model="searchQuery1" aria-controls="datatables">
                </el-input>
              </base-input>
            </div>
            <el-table :data="queriedDataCancelled">
              <el-table-column :min-width="200" align="left" label="User Details">
                <div slot-scope="props">
                  <div style="display: flex">
                    <div>
                      <div>
                        {{
                          props.row.user_id.first_name +
                            " " +
                            props.row.user_id.last_name
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </el-table-column>
              <el-table-column :min-width="200" align="left" label="Booked Time">
                <div slot-scope="props">
                  <div>
                    {{ getBookingDateTime(props)}}
                  </div>
                </div>
              </el-table-column>
              <el-table-column :min-width="200" align="left" label="Cancelled Time">
                <div slot-scope="props">
                  <div>
                    {{ props.row.canceled_at ? getCancelledDateTime(props) : "No cancelled time" }}
                  </div>
                </div>
              </el-table-column>
              <el-table-column :min-width="200" align="center" label="Cancellation Charge">
                <div slot-scope="props">
                  <div>
                    {{ props.row.isShowCharge ? props.row.totalPrice : "" }}
                  </div>
                </div>
              </el-table-column>
              <el-table-column :min-width="200" align="left" label="Pay Cancelled Charge">
                <div slot-scope="props">
                  <div>
                    {{ props.row.isShowCharge ? `${props.row.totalCharge} (total cancel spot - ${props.row.totalChargeSpots})` : "" }}
                  </div>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div slot="footer" class="
              col-12
              d-flex
              justify-content-center justify-content-sm-between
              flex-wrap
            ">
            <div class="">
              <p class="card-category">
                Showing {{ from1 + 1 }} to {{ to1 }} of {{ total1 }} entries
              </p>
            </div>
            <base-pagination class="pagination-no-border" v-model="pagination1.currentPage"
              :per-page="pagination1.perPage" :total="total1">
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-12" v-if="wait_list_users_id">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">Waitlist Users List</h4>
          <div>
            <div class="
                d-flex
                justify-content-center justify-content-sm-between
                flex-wrap
              ">
              <el-table :data="queriedDataWaitList">
                <el-table-column :min-width="200" align="left" label="User Details">
                  <div slot-scope="props">
                    <div style="display: flex">
                      <div>
                        <div>
                          {{
                            props.row.first_name +
                              " " +
                              props.row.last_name
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </el-table-column>
                <el-table-column :min-width="150" align="left" label="Date Time Added">
                  <div slot-scope="props">
                    <div style="display: flex">
                      <div>
                        <div>
                          {{
                            props.row.created_at
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </el-table-column>
                <el-table-column :min-width="200" align="center" label="Status">
                  <div slot-scope="props">
                    <div align="center">
                      <base-button native-type="submit" type="danger" value="Remove" size="sm"
                        @click="removeWaitList(props.row._id)" class="btn-fill" :disabled="loading"> Remove
                      </base-button>
                    </div>
                  </div>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </card>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-12" v-if="this.walkinTableList.length > 0">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">Walkin Bookings List</h4>
          <div>
            <div class="
                d-flex
                justify-content-center justify-content-sm-between
                flex-wrap
              ">
              <el-table :data="this.walkinTableList">
                <el-table-column :min-width="200" align="left" label="User Details">
                  <div slot-scope="props">
                    <div style="display: flex">
                      <div>
                        <div>
                          {{
                            props.row.first_name +
                              " " +
                              props.row.last_name
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </el-table-column>
                <el-table-column :min-width="150" align="left" label="Phone">
                  <div slot-scope="props">
                    <div style="display: flex">
                      <div>
                        <div>
                          {{
                            props.row.phone_number
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </el-table-column>
                <el-table-column :min-width="150" align="left" label="booked spots">
                  <div slot-scope="props">
                    <div style="display: flex">
                      <div>
                        <div>
                          {{
                            props.row.guest
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </el-table-column>
                <el-table-column :min-width="150" align="left" label="Amount">
                  <div slot-scope="props">
                    <div style="display: flex">
                      <div>
                        <div>
                          {{
                            props.row.amount
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </el-table-column>
                <el-table-column :min-width="140" align="left" label="Waiver Form" v-if="this.event.waiver_form_mandatory">
                <div slot-scope="props">
                  <base-button style="margin-right: 5px" native-type="submit" type="primary" value="Compares" size="sm" v-if="props.row.waiver_form" 
                    @click="downloadWalkinPDF(props.row.waiver_form)" class="btn-fill" :disabled="loading">Waiver Form
                  </base-button>
                </div>
              </el-table-column>
              </el-table>
            </div>
          </div>
        </card>
      </div>
    </div>

    <div class="row loader-pos">
      <div class="sk-chase" v-if="loading">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>

      <div class="no-data-message" v-if="noDataMessage">
        <div>There are no records found</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { Modal, BaseAlert, BaseInput, BasePagination, Select2Ajax } from "src/components";
import Fuse from "fuse.js";
import moment from "moment";

export default {
  components: {
    Select2Ajax,
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal,
    BaseInput,
    BaseAlert,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    // queriedData() {
    //   let result = this.tableData;
    //   result.sort((item1, item2) => {
    //     let name1 = item1.user_id.first_name + " " + item1.user_id.last_name;
    //     let name2 = item2.user_id.first_name + " " + item2.user_id.last_name;
    //     return name1.localeCompare(name2)
    //   });
    //   if (this.searchedData.length > 0) {
    //     result = this.searchedData;
    //   }
    //   let queriedData = result.slice(this.from, this.to);
    //   console.log('queriedData', queriedData);
    //   return queriedData;
    // },
  queriedDataBooked() {
  let result = this.tableData.filter((item) => item.booking_status === "Booked");
  // this.BookedData = result;
  result.sort((item1, item2) => {
    let name1 = item1.user_id.first_name + " " + item1.user_id.last_name;
    let name2 = item2.user_id.first_name + " " + item2.user_id.last_name;

    // Custom sorting function to handle numeric values in the first name
    const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
    return collator.compare(name1, name2);
  });

  if (this.searchedData.length > 0) {
    result = this.searchedData.filter((item) => item.booking_status === "Booked");
  }

  let queriedData = result.slice(this.from, this.to);
  console.log("queriedDataBooked", queriedData);
  return queriedData;
},
  // Filtered data for Cancelled status
  queriedDataCancelled() {
    let result = this.tableData.filter((item) => item.booking_status === "Cancelled");
    // this.CancelledData = result;
    result.sort((item1, item2) => {
      let name1 = item1.user_id.first_name + " " + item1.user_id.last_name;
      let name2 = item2.user_id.first_name + " " + item2.user_id.last_name;

      const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" });
      return collator.compare(name1, name2);
    });

    if (this.searchedData1.length > 0) {
      console.log("searchedData1", this.searchedData1);
      result = this.searchedData1.filter((item) => item.booking_status === "Cancelled");
    }

    let queriedData = result.slice(this.from1, this.to1);
    console.log("queriedDataCancelled", queriedData);
    return queriedData;
  },
    queriedDataWaitList() {
      let resultWaitList = this.tableWaitList;
      return resultWaitList.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.BookedData.length;
    },
    to1() {
      let highBound = this.from1 + this.pagination1.perPage;
      if (this.total1 < highBound) {
        highBound = this.total1;
      }
      return highBound;
    },
    from1() {
      return this.pagination1.perPage * (this.pagination1.currentPage - 1);
    },
    total1() {
      return this.searchedData1.length > 0
        ? this.searchedData1.length
        : this.CancelledData.length;
    },
  },
  data() {
    return {
      // Phase 1 — Task 3E: needed for role-based visibility of the Charge No Show button
      role: window.localStorage.getItem("role"),
      showLateFeeModal: false,
      deleteConfirm: false,
      showModal: true,
      selectedAjax: '-1',
      optionsAjax: [{ id: -1, text: '' }],
      noDataMessage: "",
      wait_list_users_id: false,
      loading: false,
      modals_classic: false,
      actions: [],
      message: "",
      groupMessage: "",
      noShowFeeAmount: 65,
      selectedUser: null,
      skill_level: "",
      skill_level_optional:"",
      gender: "",
      team: "",
      // Pre-existing team bug: template dereferences this.event.event_type before
      // the async data load completes. Initialising to {} (instead of null) makes
      // every `this.event.X` access return undefined harmlessly during initial
      // render. After load, this.event gets reassigned to the real event object.
      event: {},
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      pagination1: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      searchQuery1: "",
      propsToSearch: ["name", "email", "age"],
      tableColumns: [
        {
          prop: "name",
          label: "Name",
          minWidth: 200,
        },
        {
          prop: "email",
          label: "Email",
          minWidth: 250,
        },
        {
          prop: "age",
          label: "Age",
          minWidth: 100,
        },
        {
          prop: "salary",
          label: "Salary",
          minWidth: 120,
        },
      ],
      tableWaitList: [],
      tableData: [],
      searchedData: [],
      searchedData1: [],
      BookedData: [],
      CancelledData: [],
      fuseSearch: null,
      currentOrder: {},
      eve_id: "",
      walkinTableList: [],
      waiverFormList: [],
      credit_refund: false,
      is_team: false,
      teamId: "",
    };
  },
  methods: {
    mounted() {
      console.log('Props:', this.props);
    },
    getBookDate(props) {
      return moment(props.row.check_in_time).format("DD-MM-YYYY");
    },
    getTime(props) {
      console.log('***** getTime *****');
      console.log('props', props);
      console.log(props.row.check_in_time.toString().slice(0, 16).replace('T', ' '))
      console.log(moment(props.row.check_in_time).format("hh:mm A"))
      return moment(props.row.check_in_time).format("hh:mm A")
    },
    getBookingDateTime(props){
      return moment(props.row.created_at).format('MMMM Do YYYY, h:mm:ss a')
    },
    getCheckInDateTime(props){
      return moment(props.row.check_in_time).format('MMMM Do YYYY, h:mm:ss a')
    },
    getCancelledDateTime(props){
      return moment(props.row.canceled_at).format('MMMM Do YYYY, h:mm:ss a')
    },
    async deleteBookingModal(bookingId) {
      //if (!this.event.full) return;
      console.log('this:', this);
      this.selectedUser = bookingId;
      console.log('selectedUser:', this.selectedUser);
      this.deleteConfirm = true;

    },
    async deleteBookingGuest(sendMessageToWaitlistUsers) {
      if (sendMessageToWaitlistUsers == 1) {
        let event = await this.$apiService.postCall(
          `booking/delete-guest/${this.selectedUser}`,
          {
            sendMessageToWaitlistUsers: sendMessageToWaitlistUsers,
          }
        );
        this.$apiService.notify(event.apidata.Data);
        await new Promise(r => setTimeout(r, 1000));
        window.location.reload();
      } else {
        this.deleteConfirm = false;
      }

    },
    async removeWaitList(userId) {
      let isConfirmed = confirm('Are you sure you want to remove this user from wait list?');
      if (isConfirmed) {
        var event_id = this.$route.query.event_id;
        const event = await this.$apiService.postCall(
          "event/remove-wait-list/",
          {
            event_id: event_id,
            user_id: userId
          }
        );
        this.$apiService.notify("The Wait List User has been deleted.");
        await new Promise(r => setTimeout(r, 1000));
        window.location.reload();
      }
    },
    async cancelBooking(bookingId, user_id) {
      let bookings = this.event.Bookings;
      let teamBooking = bookings.filter(booking => booking._id === bookingId && 'team_id' in booking);
      if (this.event.event_type == "Tournament" && teamBooking.length > 0) {
        let isConfirmedForTeam = confirm('Are you sure you want to cancel the full team bookings?');
        if (isConfirmedForTeam) {
          this.loading = true;
          const eventDate = moment(this.event.date, 'YYYY-MM-DD');
          const eventStartTime = moment(this.event.start_time, 'hh:mm');

          const previousDay = eventDate.clone().subtract(1, 'days');

          const previousDayWithTime = previousDay.clone().set({
            hour: eventStartTime.get('hour'),
            minute: eventStartTime.get('minute'),
          });

          const currentDatetime = moment();

          if (currentDatetime.isBefore(previousDayWithTime)) {
            console.log('current date & time is before 24 hr.');
            let event = await this.$apiService.postCall(
              `booking/update-bookingstatusForTeam/${bookingId}`, {
              "booking_status": "Cancelled",
              "user_id": user_id._id,
              "isBefore": true
            }
            );
            this.$apiService.notify("The team booking has been cancelled.");
            await new Promise(r => setTimeout(r, 1000));
            this.loading = false;
            window.location.reload();
          } else {
            console.log('current date & time is after 24 hr.');
            let event = await this.$apiService.postCall(
              `booking/update-bookingstatusForTeam/${bookingId}`, {
              "booking_status": "Cancelled",
              "user_id": user_id._id,
              "isBefore": false
            }
            );
            this.$apiService.notify("The team booking has been cancelled.");
            await new Promise(r => setTimeout(r, 1000));
            this.loading = false;
            window.location.reload();
          }
        }
      } else {
        let isConfirmed = confirm('Are you sure you want to cancel the booking?');
        // if (isConfirmed) {
        //   let event = await this.$apiService.postCall(
        //     `booking/update-bookingstatus/${bookingId}`, {
        //     "booking_status": "Cancelled",
        //     "force_give_pass_to_user": true
        //   }
        //   );
        //   this.$apiService.notify("The booking has been cancelled.");
        //   await new Promise(r => setTimeout(r, 1000));
        //   window.location.reload();
        // }
        if (isConfirmed) {
          this.loading = true;
          const eventDate = moment(this.event.date, 'YYYY-MM-DD');
          const eventStartTime = moment(this.event.start_time, 'hh:mm');

          const previousDay = eventDate.clone().subtract(1, 'days');

          const previousDayWithTime = previousDay.clone().set({
            hour: eventStartTime.get('hour'),
            minute: eventStartTime.get('minute'),
          });
          // console.log(previousDayWithTime)

          const currentDatetime = moment();
          // console.log(currentDatetime)

          if (currentDatetime.isBefore(previousDayWithTime)) {
            console.log('current date & time is before 24 hr.');
            let event = await this.$apiService.postCall(
              `booking/update-bookingstatus-v1/${bookingId}`, {
              "booking_status": "Cancelled",
              "user_id": user_id._id,
              "isBefore": true
            }
            );
            if (event.apidata.Code == "BOK006") {
              this.$apiService.notify("Guest is available, So you can not able to cancel this User.");
            } else {
              this.$apiService.notify("The booking has been cancelled.");
            }
            await new Promise(r => setTimeout(r, 1000));
            this.loading = false;
            window.location.reload();
          } else {
            console.log('current date & time is after 24 hr.');
            let event = await this.$apiService.postCall(
              `booking/update-bookingstatus-v1/${bookingId}`, {
              "booking_status": "Cancelled",
              "user_id": user_id._id,
              "isBefore": false
            }
            );
            if (event.apidata.Code == "BOK006") {
              this.$apiService.notify("Guest is available, So you can not able to cancel this User.");
            } else {
              this.$apiService.notify("The booking has been cancelled.");
            }
            await new Promise(r => setTimeout(r, 1000));
            this.loading = false;
            window.location.reload();
          }
        }
      }
    },
    async UpdateStatus(user) {
      var event_id = this.$route.query.event_id;

      var postdata = {
        event_id: event_id,
        user_id: user._id,
      };
      const event = await this.$apiService.postCall(
        "booking/check-in/",
        postdata
      );
      console.log(event);
      //debugger;

      this.$apiService.notify("Status Has been Updated.");
      window.location.reload();
      //debugger;
    },
    async UpdateStatusAsOut(user) {
      var event_id = this.$route.query.event_id;

      var postdata = {
        event_id: event_id,
        user_id: user._id,
      };
      // console.log(user._id);
      const event = await this.$apiService.postCall(
        "booking/check-out/",
        postdata
      );
      // console.log(event);
      //debugger;

      this.$apiService.notify("Status Has been Updated.");
      window.location.reload();
    },
    async addGuest() {
      this.loading = true;
      var event_id = this.$route.query.event_id;
      let event = await this.$apiService.getCall("user/add-guest/" + event_id);
      debugger;
      if (event.apidata.Message !== "Success") {
        this.$apiService.notify(event.apidata.Message);
      } else {
        this.$apiService.notify("Guest Booking is successfully created.");
        await new Promise(r => setTimeout(r, 1000));
        window.location.reload();
      }
      this.loading = false;
    },
    async addTeam() {
      this.loading = true;
      var event_id = this.$route.query.event_id;
      let event = await this.$apiService.getCall("user/add-team/" + event_id);
      debugger;
      if (event.apidata.Message !== "Success") {
        this.$apiService.notify(event.apidata.Message);
      } else {
        this.$apiService.notify("Team Booking is successfully created.");
        await new Promise(r => setTimeout(r, 1000));
        window.location.reload();
      }
      this.loading = false;
    },
    // async CancelEvent(message) {
    //   let isConfirmed = confirm(`Are you sure you want to cancel the ${this.event.event_type == 'Tournament' ? "Tournament" : "Event"}?`);
    //   if (isConfirmed) {
    //     this.loading = true;
    //     let event_id = this.$route.query.event_id;
    //     //Remove wait list
    //     for (let i = 0; i < this.tableWaitList.length; i++) {
    //       await this.$apiService.postCall(
    //         "event/remove-wait-list/",
    //         {
    //           event_id: event_id,
    //           user_id: this.tableWaitList[i]._id,
    //           message: message,
    //         }
    //       );
    //     }
    //     //Remove all bookings
    //     this.tableData = this.tableData.filter((item) => item.booking_status === "Booked")
    //     for (let i = 0; i < this.tableData.length; i++) {
    //       console.log(this.tableData[i] , i)
    //       if (this.tableData[i].user_id.is_guest) {
    //         console.log("FAKE USER ID",this.tableData[i]._id)
    //         await this.$apiService.postCall(
    //           `booking/delete-guest/${this.tableData[i]._id}`
    //         );
    //       } else {  
    //         console.log("credit refund", this.credit_refund)
    //         let booking_cancel = await this.$apiService.postCall(
    //           `booking/update-bookingstatus/${this.tableData[i]._id}`, {
    //           "booking_status": "Cancelled",
    //           "user_id" : this.tableData[i].user_id._id,
    //           "isBefore" : true,
    //           "isCancelAll" : true,
    //           "credit_refund" : this.credit_refund,
    //         },
    //         );
    //         // console.log("REAL USER ID",this.tableData[i].user_id._id)
    //         // console.log("EVENT",this.event)
    //         // let guestUser = this.event.Bookings.filter((b) => {
    //         //   console.log(this.tableData[i].user_id._id,b.user_id)
    //         //   return this.tableData[i].user_id._id == b.user_id && b.booking_status == "Booked"
    //         // })

    //         // console.log("guestUser",guestUser)

    //         if (booking_cancel.isError === false) {
    //           // console.log("in !booking_cancel.isError")
    //           let guestUser = this.event.Bookings.filter((b) => {
    //           console.log(this.tableData[i].user_id._id,b.user_id)
    //           return this.tableData[i].user_id._id == b.user_id && b.booking_status == "Booked"
    //           })
    //           let USERID;
    //           if(guestUser.length > 0){
    //             if("user_initiator_id" in guestUser[0]){
    //               USERID = guestUser[0].user_initiator_id;
    //             } else {
    //               USERID = guestUser[0].user_id;
    //             }
    //           }

    //           // let send_message = await this.$apiService.postCall(
    //           //   `message/sendtextmessage/${this.tableData[i].user_id._id}`, {
    //           //   message: message,
    //           // })

    //           console.log(USERID)
    //           let send_message = await this.$apiService.postCall(
    //             `message/sendtextmessage/${USERID}`, {
    //             message: message,
    //           })
    //         } else {
    //           console.log("error");
    //         }
    //       }
    //     }
    //     this.$apiService.notify("The booking has been cancelled.");
    //     await new Promise(r => setTimeout(r, 2000));
    //     this.loading = false;
    //     window.location.reload();
    //   }
    //   return;
    // },

    async CancelEvent(message) {
      let isConfirmed = confirm(`Are you sure you want to cancel the ${this.event.event_type == 'Tournament' ? "Tournament" : "Event"}?`);
      if (isConfirmed) {
        this.loading = true;
        let event_id = this.$route.query.event_id;
        const response = await this.$apiService.postCall(
          `booking/cancel-all-bookings/${event_id}`, {
          message,
          "credit_refund": this.credit_refund,
        })
        console.log("response", response)
        if (response.apidata.Code == "P00001") {
          this.$apiService.notify("The booking has been cancelled.");
          await this.fetchData();
        } else {
          this.$apiService.notify("Unable to cancel booking.");
        }
        this.$bvModal.hide('modal-1');
        this.message = "";
        this.loading = false;
      }
    },

    async sendGroupMessage(groupMessage) {
      let isConfirmed = confirm('You want to send message to the Group?');
      if (isConfirmed) {
        this.loading = true;
        const sendMessage = await this.$apiService.postCall(
          `message/groupsendmessage/${this.event._id}`, {
          message: groupMessage,
        })
        console.log("sendMessage", sendMessage)
        if (sendMessage.apidata.Code == "P00001") {
          this.$apiService.notify("The message has been sent successfully to the group.");
        } else {
          this.$apiService.notify("Unable to send message to the group.");
        }
        this.$bvModal.hide('modal-2');
        this.groupMessage = "";
        this.loading = false;
      }
      return;
    },

    async chargeNoShow(booking) {
      console.log("booking",booking)
      this.selectedUser = booking.user_id;
      if (booking.event_id.event_type == "Tournament") {
        if ("team_id" in booking) {
          console.log("team member")
          this.noShowFeeAmount = 100;
          this.showLateFeeModal = true;
          this.is_team = true;
          this.teamId = booking.team_id;
        } else {
          console.log("individual")
          this.noShowFeeAmount = 65;
          this.showLateFeeModal = true;
          this.is_team = false;
        }
      } else {
        this.noShowFeeAmount = 65;
        this.showLateFeeModal = true;
        this.is_team = false;
      }
    },

    async addLateFee(user) {
      this.loading = true;
      const event_id = this.$route.query.event_id;
      var postdata = {
        event_id: event_id,
        user_id: user._id,
        status: "Unpaid",
        late_fee: this.noShowFeeAmount
      };
      if (this.is_team) postdata.user_id = this.teamId
      const event = await this.$apiService.postCall(
        "late-fee/add-late-fee",
        postdata
      );
      if (event.apidata.Code == "LFE001") {
        this.$apiService.notify("Late fee already charge to user for this event.");
      } else {
        this.$apiService.notify("No show fee has been added.");
        await new Promise(r => setTimeout(r, 1000));
        window.location.reload();
      }
      this.showLateFeeModal = false;
      this.loading = false;
    },

    async downloadPDF(event) {
      const pdf = event.target.value;
      console.log("pdf ===> ",pdf)
      await this.downloadPdf(pdf);
      event.target.value = "";
      this.$apiService.notify("Waiver form downloaded successfully.");
    },

    async downloadWalkinPDF(pdf) {
      console.log("pdf ===> ",pdf)
      await this.downloadPdf(pdf);
      this.$apiService.notify("Waiver form downloaded successfully.");
    },

    async downloadAllWaiverForms() {
      if (this.waiverFormList.length) {
        this.waiverFormList.map(async (pdf) => {
          console.log("pdf",pdf.pdfUrl)
          await this.downloadPdf(pdf.pdfUrl);
        })
        this.$apiService.notify("All Waiver form downloaded successfully.");
      } else {
        this.$apiService.notify("No available waiverform in the list.");
      }
    },

    async downloadPdf(pdfUrl) {
      try {
        const response = await fetch(pdfUrl);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = pdfUrl.split('/').pop(); // Use the last part of the URL as the file name 
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error downloading the PDF:', error);
      }
    },

    async fetchData() {
      this.loading = true;
      let event_id = this.$route.query.event_id;
      this.eve_id = event_id;
      var postdata = { event_id: event_id };
      let eventBookings = await this.$apiService.postCall("booking/eventBookings", postdata);
      if (eventBookings.apidata.Code == 'BOK002') {
        this.$apiService.notify("Something went wrong to get booking data. Please, Refresh the page.");
        this.loading = false;
        return;
      }
      let eve = await this.$apiService.postCall("event/eventbyId/" + this.eve_id);
      // Defend against API error responses (Data: null on ACC003, EVE002, etc.)
      this.event = (eve && eve.apidata && eve.apidata.Data && eve.apidata.Data.event) || {};
      console.log('this.event', this.event);

      if (eventBookings.apidata && eventBookings.apidata.Data && eventBookings.apidata.Data.length > 0) {
        eventBookings.apidata.Data.map((data) => {
          console.log(data.check_in_status);
        });
        this.wait_list_users_id = eventBookings.apidata.Data[0].wait_lists.length > 0 ? true : false;
        this.tableWaitList = eventBookings.apidata.Data[0].wait_lists || [];
      }
      this.tableData = eventBookings.apidata && eventBookings.apidata.Data ? eventBookings.apidata.Data : [];
      console.log('this.tableData', this.tableData);

      this.BookedData = this.tableData.filter((item) => item.booking_status === "Booked");
      this.CancelledData = this.tableData.filter((item) => item.booking_status === "Cancelled");

      let walkinBookings = await this.$apiService.getCall("user/get-walkin-players/" + this.eve_id);
      this.walkinTableList = walkinBookings.apidata.Data ? walkinBookings.apidata.Data : [];
      console.log("walkin player list", this.walkinTableList)

      if (this.event.event_type == 'Tournament' && this.event.waiver_form_mandatory) {
        let allWaiverFormForTournament = await this.$apiService.getCall("booking/get-waiver-form-list/" + this.eve_id);
        this.waiverFormList = allWaiverFormForTournament.apidata.Data && allWaiverFormForTournament.apidata.Data.waiver_form_list ? allWaiverFormForTournament.apidata.Data.waiver_form_list : [];
        console.log("waiverFormList", this.waiverFormList, this.waiverFormList.length)
      }
      this.loading = false;
    }
  },

  async mounted() {
    await this.fetchData();
  },

  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      console.log("searchQueryValue",value,this.searchQuery);
      let result = this.BookedData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
        result = result.map(a => console.log("167",a));
      }
      console.log("result",result);
      this.searchedData = result;
    },
    searchQuery1(value) {
      console.log("searchQueryValue", value, this.searchQuery);
      let result = this.BookedData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery1);
        result = result.map(a => console.log("167",a));
      }
      console.log("result",result);
      this.searchedData = result;
    },
// searchQuery(value) {
//   console.log("searchQueryValue:", value);

//   // if (typeof value === "string" && value.trim() !== "") {
//     if (value !== "") {
//     const results = this.fuseSearch.search(value.trim());
//     console.log("Raw Results:", results);

//     // Extract matched items
//     this.searchedData = results.map(result => console.log(result));
//     console.log("Matched Data:", this.searchedData);
//   } else {
//     console.log("Empty or invalid search query.");
//     this.searchedData = this.BookedData; // Reset to default data
//   }
// },
//     searchQuery1(value) {
//       let result = this.cancelledData;
//       // if (value !== "") {
//       //   result = this.fuseSearch.search(this.searchQuery1);
//       // }
//       // this.searchedData1 = result;
//       if (this.searchQuery1 !== "") {
//         result = this.fuseSearch.search(this.searchQuery1);
//         console.log("166",result);
//         result = result.map(a => console.log("167",a));
//       }
//       this.searchedData1 = result;
//     },
  },
};
</script>
<style>
.pagination-select,
.search-input {
  width: 200px;
}

.swal2-icon-content {
  font-size: inherit !important;
}

.selection {
  height: 39px;
}

.select2-container--default .select2-selection--single .select2-selection__arrow {
  height: 36px;
}

.form-group .el-input__inner,
.form-group .el-input__inner:focus {
  color: #0c2646;
}

.location {
  background: #27293d !important;
  border: 1px solid #2b3553;
  padding: 8px;
  font-size: 14px;
  border-radius: 5px;
  width: 100%;
  color: white;
}

.loader-pos {
  margin-top: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
}

.waiver-dropdown{
  width: 100%;
}
</style>
